/**
 * Croatian — every string this portal says.
 *
 * Translated from the Slovenian original, which is the source of truth for the
 * vocabulary: the words for a stamp, a shift, a change to one and a decision about
 * leave are the words the rest of this product uses, and a second wording would be a
 * second feature as far as anybody comparing two screens is concerned.
 */
export default {
    app: {
        name: "Zaposlenici",
    },
    errors: {
        conflict: "Zapis je već zauzet ili postoji",
        generic_error: "Došlo je do pogreške",
        invalid_data: "Neispravni podaci",
        module_not_licensed: "Modul nije uključen za ovaj hotel",
        not_found: "Nije pronađeno",
        on_add: "Pogreška pri dodavanju",
        on_edit: "Pogreška pri uređivanju",
        on_load: "Pogreška pri učitavanju",
        operation_in_progress: "Ovaj žig se već upisuje. Ne pritišći ponovno — za trenutak će biti vidljiv.",
        operation_mismatch: "Zaslon je zastario. Osvježi stranicu i pokušaj ponovno.",
        session_expired: "Sesija je istekla. Prijavi se ponovno — ništa nije učinjeno.",
        staff_break_recording_off: "Kuća ne bilježi pauze.",
        staff_not_employed: "Za taj dan nemaš važeći kadrovski karton, pa žig nije moguće upisati. Reci voditelju ili kadrovskoj službi.",
        staff_time_busy: "Žig se već upisuje. Pokušaj ponovno za trenutak.",
        staff_time_month_closed: "Ovaj mjesec je zaključen i više ga nije moguće mijenjati. Ako je riječ o pogrešci, obrati se voditelju — ponovno ga može otvoriti samo kadrovska.",
        staff_time_out_of_range: "Vrijeme žiga je izvan dopuštenog okvira.",
        staff_time_sequence: "Redoslijed žigova nije moguć (npr. dolazak na već otvoren dan).",
        unauthorized: "Nemaš prava za ovu radnju",
    },
    general: {
        hint: 'Napomena',
        cancel: "Odustani",
        hide_password: "Sakrij lozinku",
        save: "Spremi",
        show_password: "Prikaži lozinku",
    },
    home: {
        needs_you: "Čeka tvoj odgovor",
        no_shift_today: "Za danas nema objavljene smjene.",
        open_clock: "Svi žigovi",
        waiting_on_others: "Čeka odgovor kuće",
    },
    license: {
        contact: "Za uključenje obrati se sistemskom administratoru. Podaci kuće ostaju netaknuti.",
        lead: "Modul »Zaposlenici i vrijeme« nije dio pretplate ove kuće, pa ovaj portal ne može ništa prikazati.",
        switch_account: "Prijavi se drugim računom",
        title: "Ova usluga nije uključena",
    },
    login: {
        demo_signing_in: "Prijavljujem …",
        demo_failed: "Ta uloga ne postoji na ovom poslužitelju.",
        failed: "Pogrešno korisničko ime ili lozinka",
        password: "Lozinka",
        remember: "Ostani prijavljen",
        remember_hint: "Na svom telefonu. Na tuđem se radije ne prijavljuj trajno.",
        same_account: "Prijavi se istim korisničkim imenom i lozinkom kao u PMS-u. Lozinku ovdje nije moguće poništiti — za to se obrati administratoru.",
        submit: "Prijava",
        subtitle: "Moj sat, moj raspored, moj godišnji odmor i moji dokumenti.",
        title: "Prijava",
        username: "Korisničko ime",
    },
    nav: {
        account: "Račun",
        clock: "Sat",
        documents: "Dokumenti",
        home: "Početna",
        language: "Jezik",
        language_de: "Deutsch",
        language_en: "English",
        language_hr: "Hrvatski",
        language_hu: "Magyar",
        language_it: "Italiano",
        language_sl: "Slovenščina",
        leave: "Godišnji",
        logout: "Odjava",
        profile: "Moj profil",
        rota: "Raspored",
        theme: "Izgled",
        theme_dark: "Tamno",
        theme_light: "Svijetlo",
        theme_system: "Sistemski",
    },
    notifications: {
        channel_email: "E-pošta",
        channel_email_hint: "Potrebna je tvoja e-adresa.",
        channel_messaging: "Aplikacije za poruke",
        channel_messaging_hint: "Potreban je tvoj WhatsApp broj ili povezani Viber.",
        channel_push: "Aplikacija na telefonu",
        channel_push_hint: "Potreban je službeni telefon ili sat koji je uparen s tobom.",
        channel_sms: "SMS",
        channel_sms_hint: "Potreban je tvoj broj telefona.",
    },
    profile: {
        account_hint: "Tko si u sustavu.",
        account_managed_elsewhere: "Ime, korisničko ime i lozinku uređuje administrator sustava. Ovdje ih nije moguće promijeniti.",
        account_title: "Račun",
        card_hint: "Što kuća ima zapisano o tvojem radu.",
        card_read_only: "Karton uređuje kadrovska služba. Ako nešto ne stoji, reci joj — ispravak je novi karton, a ne popravljeni stari.",
        card_title: "Moj kadrovski karton",
        channel_unavailable: "Kuća ovaj način (još) nema postavljen.",
        channels: "Načini obavještavanja",
        channels_hint: "Ništa odabrano znači sve načine koje kuća ima. Sivi način znači da ga kuća nije postavila.",
        contact_hint: "Kamo kuća treba poslati obavijest o rasporedu. Ti podaci su tvoji i sam ih uređuješ.",
        contact_title: "Moji podaci za obavještavanje",
        department: "Odjel",
        email: "E-adresa",
        email_hint: "Ovamo stiže obavijest o objavi rasporeda i o promjeni smjene.",
        employee_no: "Interni broj",
        engagement: "Pravna osnova",
        hours_per_week: "{hours} sati tjedno",
        language_hint: "Vrijedi za ovaj uređaj. Jezik na računu postavlja kadrovska služba i on određuje na kojem se jeziku portal otvori prvi put.",
        manager: "Nadređeni",
        name: "Ime",
        no_card: "Za danas nema važećeg kartona.",
        no_card_hint: "To je uobičajeno prvi dan ili između sezona. Ako radiš, reci kadrovskoj.",
        period: "Razdoblje",
        period_from: "od {date}",
        phone: "Telefon",
        phone_hint: "U međunarodnom obliku: +38641123456.",
        phone_invalid: "Telefon mora biti u obliku +386… (od 8 do 15 znamenki).",
        position: "Radno mjesto",
        property: "Kuća",
        saved: "Spremljeno.",
        time_record: "Evidencija vremena",
        time_record_not_required: "Nije obvezna",
        username: "Korisničko ime",
        weekly_obligation: "Tjedna obveza",
        work_pattern: "Raspored po danima",
        working_time: "Radno vrijeme",
    },
    staff: {
        acknowledge: "Potvrđujem",
        acknowledge_failed: "Potvrdu nije bilo moguće zapisati.",
        acknowledge_hint: "Potvrdom se u evidenciju upisuje da si promjenu vidio i kada. Dok ne potvrdiš, raspoređivač vidi da još ne znaš.",
        acknowledged: "Primitak potvrđen",
        basis_agency_worker: "Agencijski radnik",
        basis_copyright_contract: "Autorski ugovor",
        basis_employment_contract: "Ugovor o radu",
        basis_other: "Druga pravna osnova",
        basis_pensioner_temporary: "Privremeni rad umirovljenika",
        basis_self_employed: "Samostalni izvođač",
        basis_service_contract: "Ugovor o djelu",
        basis_short_term_family_work: "Kratkotrajni obiteljski rad",
        basis_student_work: "Studentski rad",
        basis_traineeship: "Praktično osposobljavanje ili naukovanje",
        break_of: "pauza {minutes}",
        change_changed_at: "Promijenjeno {at}",
        change_moved: "Iz {previous} u {current}",
        change_reason_line: "Razlog: {reason}",
        change_withdrawn: "Smjena je otkazana (bila je {previous})",
        day_friday: "pet",
        day_monday: "pon",
        day_saturday: "sub",
        day_sunday: "ned",
        day_thursday: "čet",
        day_tuesday: "uto",
        day_wednesday: "sri",
        decline: "Ne mogu",
        decline_failed: "Odgovor nije bilo moguće zapisati.",
        decline_hint: "Raspoređivač će vidjeti da ne možeš i potražit će zamjenu. Promjena ostaje na popisu dok to ne riješi.",
        decline_note: "Zašto ne možeš? (neobvezno)",
        decline_send: "Pošalji",
        decline_title: "Ne mogu raditi",
        declined: "Zabilježeno: ne možeš.",
        duration_fixed_term: "Određeno vrijeme",
        duration_indefinite: "Neodređeno vrijeme",
        exempt_managing_person: "Poslovodna osoba",
        exempt_other: "Drugi razlog",
        free_day: "Slobodno",
        load_failed: "Podatke nije bilo moguće pročitati.",
        my_changes_title: "Promjene koje još nisi potvrdio: {count}",
        my_pending_title: "Zahtjevi koji čekaju odluku: {count}",
        my_rota: "Moj raspored",
        my_rota_empty: "Ovaj tjedan nemaš raspoređenu smjenu.",
        my_rota_empty_hint: "Ono što ovdje vidiš samo je objavljeno. Nacrte raspoređivača ne prikazuje — dok tjedan nije objavljen, nije obećanje.",
        next_week: "Sljedeći tjedan",
        no_swap_hint: "Zamjenu smjene s kolegom i molbe za zamjenu ovaj portal nema. Ako smjenu ne možeš raditi, pritisni »Ne mogu« kod promjene gore — voditelj to odmah vidi, zajedno s razlogom. Za planiranu odsutnost predaj zahtjev za godišnji odmor.",
        previous_week: "Prošli tjedan",
        record_clock: "Žigova",
        record_manual: "Ručnog unosa",
        record_pattern: "Radnog uzorka",
        record_schedule: "Rasporeda",
        state_cancelled: "Otkazano",
        state_draft: "Nacrt",
        state_published: "Objavljeno",
        this_week: "Ovaj tjedan",
        time_full: "Puno radno vrijeme",
        time_part: "Skraćeno radno vrijeme",
        today: "Danas",
        try_again: "Pokušaj ponovno",
        unit_hours: "h",
        unit_minutes: "min",
    },
    staff_absence: {
        days_recorded: "Evidentiranih dana: {count}",
        decided_by_other: "O zahtjevu odlučuje netko drugi — svoj ne možeš potvrditi sam.",
        from: "Od",
        kind: "Vrsta",
        kind_business_trip: "Službeni put",
        kind_holiday: "Praznik",
        kind_other: "Drugo",
        kind_sick_leave: "Bolovanje",
        kind_training: "Edukacija",
        kind_unexcused: "Neopravdana odsutnost",
        kind_vacation: "Godišnji odmor",
        my_absences: "Moje odsutnosti",
        my_absences_hint: "Tvoji zahtjevi i odluke o njima. Odbijeni ostaju vidljivi — odbijenica koja nestane je odbijenica koja se nije dogodila.",
        no_my_requests: "Nemaš zahtjeva za odsutnost.",
        note: "Napomena",
        other_kinds_hint: "Zatražiti je moguće samo godišnji odmor. Bolovanje javljaš voditelju, koji ga upisuje u evidenciju; praznik proizlazi iz kalendara kuće; edukacija i službeni put upućivanje su poslodavca. Sve se to pojavi u tvojoj evidenciji kad je upisano.",
        other_kinds_title: "Druge odsutnosti",
        range_backwards: "Kraj ne može biti prije početka.",
        range_too_long: "Zahtjev može obuhvatiti najviše {days} dana. Za dužu odsutnost dane upisuje voditelj.",
        request_hint: "Za sebe možeš zatražiti godišnji odmor. Bolovanje se prijavljuje i evidentira, praznik proizlazi iz kalendara, a edukaciju i službeni put upisuje voditelj.",
        request_leave: "Zatraži godišnji odmor",
        request_sent: "Zahtjev je poslan na odluku.",
        send_request: "Pošalji zahtjev",
        source_calendar: "Kalendar praznika",
        source_manager: "Unos voditelja",
        source_request: "Zahtjev",
        state_approved: "Odobreno",
        state_rejected: "Odbijeno",
        state_requested: "Zatraženo",
        state_withdrawn: "Povučeno",
        to: "Do",
        total_absence: "Odsutnost",
        withdraw: "Povuci",
        withdrawn: "Zahtjev je povučen.",
    },
    staff_document: {
        download: "Preuzmi",
        expired_on: "Isteklo {date}",
        expires_on: "Vrijedi do {date}",
        kind_aneks: "Aneks",
        kind_drugo: "Drugo",
        kind_m1: "Obrazac M-1",
        kind_nda: "Izjava o povjerljivosti",
        kind_odlok: "Rješenje",
        kind_pogodba: "Ugovor o radu",
        my_documents: "Moji dokumenti",
        my_documents_hint: "Ono što je kuća uložila kod tebe. Čitaš i preuzimaš; ulaže kuća.",
        no_my_documents: "Za tebe još nije uložen nijedan dokument.",
        read_only_hint: "Dokumente ovdje nije moguće dodavati ni brisati — mapa je zapis poslodavca. Potvrdu primitka ima samo rješenje o godišnjem odmoru.",
    },
    staff_month: {
        badge_closed: "Zaključeno",
    },
    staff_time: {
        break_counts_hint: "Pauza se računa u radno vrijeme i ne oduzima se.",
        break_short: "pauza {minutes}",
        correction_approved: "Potvrđen",
        correction_date: "Datum",
        correction_decided_by_other: "O zahtjevu odlučuje netko drugi — svoj ne možeš potvrditi sam.",
        correction_hint: "Zatražiti možeš sam; odlučuje netko drugi.",
        correction_kind: "Vrsta žiga",
        correction_mode_existing: "Ispravak postojećeg žiga",
        correction_mode_missing: "Žig koji nedostaje",
        correction_no_stamps: "Ovaj dan nema žiga koji bi se mogao ispraviti.",
        correction_reason: "Razlog",
        correction_rejected: "Odbijen",
        correction_requested: "Zatražen",
        correction_send: "Pošalji zahtjev",
        correction_sent: "Zahtjev je poslan na odluku.",
        correction_time: "Vrijeme",
        correction_what: "Što ispravljaš",
        correction_which_stamp: "Koji žig",
        day_open: "Dan nije zaključen — odlazak nije zabilježen.",
        decision_reason: "Razlog: {reason}",
        excess_pending: "Višak — čeka razvrstavanje",
        first_in: "dolazak {at}",
        kind_break_end: "Kraj pauze",
        kind_break_start: "Pauza",
        kind_clock_in: "Dolazak",
        kind_clock_out: "Odlazak",
        last_out: "odlazak {at}",
        month_pdf: "Mjesečni ispis (PDF)",
        my_corrections: "Moji zahtjevi za ispravak",
        my_record: "Moja evidencija",
        my_time: "Moj sat",
        next_month: "Sljedeći mjesec",
        no_days: "U ovom razdoblju nema zabilježenih dana.",
        of_which_break: "od toga pauza {minutes}",
        open: "Nedovršen",
        period_month: "Mjesec",
        period_week: "Tjedan",
        previous_month: "Prošli mjesec",
        queued: "Čeka vezu: {count}",
        refused: "Žig nije prihvaćen.",
        not_recorded: "Žig nije zabilježen: {reason}",
        request_correction: "Zatraži ispravak",
        stamped: "Zabilježeno: {kind}",
        this_month: "Ovaj mjesec",
        today_total: "Danas",
        total_balance: "Saldo",
        total_break: "Pauza",
        total_expected: "Obveza",
        total_worked: "Rad",
    },
    staff_vacation: {
        acknowledge: "Potvrđujem",
        acknowledge_hint: "Potvrđuješ PRIMITAK rješenja, a ne slaganje s brojem dana.",
        acknowledged: "Potvrđeno",
        acknowledged_toast: "Primitak rješenja je zabilježen.",
        available: "Na raspolaganju",
        bucket_current: "Novi",
        bucket_old: "Stari",
        current_leave: "Godišnji odmor {year}",
        days_count: "{count} dana",
        decision_for_year: "Rješenje za godinu {year}",
        decision_total: "Utvrđeno: {days}",
        entitled: "Utvrđeno",
        expired_days: "Isteklo {days} — rok je bio {date}.",
        issued_at: "Izdao: {who}, {at}",
        my_balance: "Moj godišnji odmor",
        my_decisions: "Moja rješenja",
        my_decisions_hint: "Rješenja o godišnjem odmoru koja ti je kuća izdala.",
        next_year: "Sljedeća godina",
        no_balance: "Za ovu godinu nema podatka o godišnjem odmoru.",
        no_balance_hint: "Saldo nastaje kad je izdano rješenje i kad osoba ima važeće razdoblje rada.",
        no_my_decisions: "Za tebe još nije izdano nijedno rješenje.",
        no_usage: "U ovoj godini nema zabilježenog korištenja godišnjeg odmora.",
        not_acknowledged: "Nije potvrđeno",
        not_issued_hint: "Rješenje za ovu godinu još nije izdano.",
        of_which_pending: "Od toga čeka odluku: {days}",
        of_which_used: "Od toga iskorišteno: {days}",
        old_leave: "Stari godišnji ({year})",
        over_remaining: "Zahtjev premašuje raspoloživih {days}. Odluka je svejedno na kući.",
        part_base: "Osnova",
        part_children: "Djeca",
        part_education: "Obrazovanje",
        part_full_year: "Ukupno (cijela godina)",
        part_responsibility: "Odgovorno radno mjesto",
        part_special: "Posebna kategorija",
        part_tenure: "Radni staž",
        pdf: "PDF",
        pending: "U odlučivanju",
        previous_year: "Prošla godina",
        requested_days: "Zatraženih radnih dana: {days}",
        still_days: "još {days}",
        still_of: "još {left} od {total}",
        this_year: "Ove godine",
        usage_history: "Povijest korištenja",
        use_by: "Iskoristi do {date}.",
        used: "Iskorišteno",
    },
    success: {
        add: "Uspješno dodano",
        edit: "Uspješno ažurirano",
    },
    validation: {
        email: "Neispravna e-adresa",
        required: "Ovo polje je obvezno",
    },
}
